import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ReactComponent as PriceGuaranteeBadge } from '../../../assets/images/svg/price-guarantee-badge.svg';
import themeColors from '../../../assets/styles/themeColors';
import { variables } from '../../../assets/styles/variables';
import { formatMoneyNumeral } from '../../../util/helpers/numeralHelpers';
import { mediaBelow } from '../../../assets/styles/helper';

const Card = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${themeColors.colorPrimary};
  border-radius: 4px;
  padding: 14px 16px;
  background: ${themeColors.colorBackgroundSecondary};
`;

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Title = styled.div`
  font-family: ${variables.family.goldSilver}, sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 18px;
  color: ${themeColors.colorTextPrimary};
  ${mediaBelow(variables.breakpoints.bpMd)} {
    font-size: 14px;
  }
`;

const LockLine = styled.div`
  font-family: ${variables.family.goldSilver}, sans-serif;
  font-size: 14px;
  line-height: 16px;
  color: ${themeColors.colorTextSecondary};
  margin-top: 2px;
`;

const PreAuthLine = styled.div`
  margin-top: 14px;
  font-family: ${variables.family.goldSilver}, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  color: ${themeColors.colorPreAuthOrange};
`;

const LearnMoreButton = styled.button`
  align-self: flex-start;
  margin-top: 4px;
  background: none;
  border: none;
  padding: 0;
  font-family: ${variables.family.goldSilver}, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
  color: ${themeColors.colorPrimary};
  text-decoration: underline;
  cursor: pointer;
`;

const SellFromHomePriceGuaranteeCard = ({ price, onLearnMore }) => {
  const { t } = useTranslation();

  return (
    <Card data-cy="card-sfh-price-guarantee">
      <TitleRow>
        <PriceGuaranteeBadge />
        <Title>{t('sellWizard.sfhWizard.quantity.priceGuarantee')}</Title>
      </TitleRow>
      <LockLine>
        {t('sellWizard.sfhWizard.quantity.lockPerUnit', {
          price: formatMoneyNumeral(price),
        })}
      </LockLine>
      <PreAuthLine>{t('sellWizard.sfhWizard.quantity.preAuth')}</PreAuthLine>
      <LearnMoreButton type="button" onClick={onLearnMore}>
        {t('sellWizard.sfhWizard.quantity.learnMore')}
      </LearnMoreButton>
    </Card>
  );
};

SellFromHomePriceGuaranteeCard.propTypes = {
  price: PropTypes.number,
  onLearnMore: PropTypes.func.isRequired,
};

export default SellFromHomePriceGuaranteeCard;
